// @sentry/react-native is used BOTH as an API (captureException, init, ...) and
// as React components (<Sentry.ErrorBoundary> wraps the whole app in
// screens/ErrorBoundary; Sentry.wrap, Sentry.TouchEventBoundary). The generic
// noopfn proxy turns ErrorBoundary into a function → "Functions are not valid as
// a React child" → blanks the app. Shim component-shaped members as passthroughs
// and everything else as no-ops.
const React = require("react");

function ErrorBoundary(props) {
  // render children; ignore Sentry's fallback/onError (no error capture on web)
  return props && props.children != null ? props.children : null;
}
function Passthrough(props) {
  return props && props.children != null ? props.children : null;
}
const noop = function () {};
const identityHOC = function (C) { return C; };

const api = new Proxy(
  {},
  {
    get(_t, prop) {
      if (prop === "__esModule") return true;
      if (prop === "default") return api;
      if (prop === "ErrorBoundary") return ErrorBoundary;
      if (prop === "TouchEventBoundary") return Passthrough;
      if (prop === "wrap" || prop === "withProfiler" || prop === "withErrorBoundary") return identityHOC;
      if (typeof prop === "symbol") return undefined;
      return noop; // init, captureException, addBreadcrumb, setTag, ...
    },
  },
);

module.exports = api;
